// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage {
  min-height: 100vh;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: all 0.3s ease;
}

.homepage-main {
  padding-top: 120px; /* Header height compensation */
  display: flex;
  flex-direction: column;
}


.cards-section {
  padding: 4rem 0;
  background: var(--bg-primary);
  position: relative;
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.cards-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(139, 69, 19, 0.3), transparent);
}

.cards-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  max-width: 1400px;
  width: 100%;
  padding: 0 2rem;
  align-items: start;
}

/* Dark theme support for cards section */
[data-theme="dark"] .cards-section {
  background: var(--bg-primary);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .cards-container {
    gap: 1.2rem;
    padding: 0 1.5rem;
  }
}

@media (max-width: 768px) {
  .cards-section {
    padding: 2rem 0;
  }
  
  .cards-container {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 0 1rem;
  }
}

@media (max-width: 480px) {
  .cards-section {
    padding: 1.5rem 0;
  }
  
  .cards-container {
    gap: 1rem;
    padding: 0 0.5rem;
  }
}

/* Services Section Styles */
.services-section {
  padding: 4rem 0;
  background: var(--bg-primary);
  position: relative;
}

.services-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(139, 69, 19, 0.3), transparent);
}

.services-container {
  max-width: 1400px;
  width: 100%;
  padding: 0 2rem;
  margin: 0 auto;
}

/* Dark theme support for services section */
[data-theme="dark"] .services-section {
  background: var(--bg-primary);
}

/* Responsive Design for Services */
@media (max-width: 1200px) {
  .services-container {
    padding: 0 1.5rem;
  }
}

@media (max-width: 768px) {
  .services-section {
    padding: 3rem 0;
  }
  
  .services-container {
    padding: 0 1rem;
  }
}

@media (max-width: 480px) {
  .services-section {
    padding: 2rem 0;
  }
  
  .services-container {
    padding: 0 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/HomePage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB,EAAE,+BAA+B;EACnD,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oFAAoF;AACtF;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".homepage {\n  min-height: 100vh;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all 0.3s ease;\n}\n\n.homepage-main {\n  padding-top: 120px; /* Header height compensation */\n  display: flex;\n  flex-direction: column;\n}\n\n\n.cards-section {\n  padding: 4rem 0;\n  background: var(--bg-primary);\n  position: relative;\n  min-height: calc(100vh - 120px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.cards-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(139, 69, 19, 0.3), transparent);\n}\n\n.cards-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  max-width: 1400px;\n  width: 100%;\n  padding: 0 2rem;\n  align-items: start;\n}\n\n/* Dark theme support for cards section */\n[data-theme=\"dark\"] .cards-section {\n  background: var(--bg-primary);\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .cards-container {\n    gap: 1.2rem;\n    padding: 0 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .cards-section {\n    padding: 2rem 0;\n  }\n  \n  .cards-container {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    padding: 0 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .cards-section {\n    padding: 1.5rem 0;\n  }\n  \n  .cards-container {\n    gap: 1rem;\n    padding: 0 0.5rem;\n  }\n}\n\n/* Services Section Styles */\n.services-section {\n  padding: 4rem 0;\n  background: var(--bg-primary);\n  position: relative;\n}\n\n.services-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(139, 69, 19, 0.3), transparent);\n}\n\n.services-container {\n  max-width: 1400px;\n  width: 100%;\n  padding: 0 2rem;\n  margin: 0 auto;\n}\n\n/* Dark theme support for services section */\n[data-theme=\"dark\"] .services-section {\n  background: var(--bg-primary);\n}\n\n/* Responsive Design for Services */\n@media (max-width: 1200px) {\n  .services-container {\n    padding: 0 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .services-section {\n    padding: 3rem 0;\n  }\n  \n  .services-container {\n    padding: 0 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .services-section {\n    padding: 2rem 0;\n  }\n  \n  .services-container {\n    padding: 0 0.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
